<template>
  <div>
    <div v-if="descriptionMessage" v-html="descriptionMessage"></div>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="p-t-20 pb-0">
        <v-select
          v-model="editedItem.methods"
          class="width150px"
          :items="methods"
          label="Method"
          dense
          hide-details
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          v-model="editedItem.url"
          label="URL"
          hide-details
          dense
          @keyup.down="pressDown"
          @keyup.up="pressUp"
          @keydown.enter="onEnter"
          @keydown.tab="pressTab"
        >
        </v-text-field>
        <intellisense
          :input="editedItem.url"
          :property="'url'"
          :start="start"
          :eventKey="eventKey"
          :functionName="this.apiFunctionName"
          @clearSelected="clearSelected"
          @updateInputFromIntellisense="updateInputFromIntellisense"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="m-t-10 pt-0 pb-0">
        <v-tabs centered fixed-tabs v-model="activeTab">
          <v-tab
            v-for="item in itemsTab"
            :id="item"
            :key="item"
            class="font-size-sub"
            @click="currentTab = item"
          >
            {{ item }}
          </v-tab>
        </v-tabs>
      </v-col>
      <v-col v-if="currentTab === 'headers'" cols="12" sm="12" md="12" lg="12">
        <fieldset class="form-group m-b-0 height200px">
          <v-row>
            <v-col cols="12" sm="5" lg="5">
              <span>Key</span>
            </v-col>
            <v-col cols="12" sm="7" lg="7" class="d-flex justify-space-between">
              <span>Value</span>
              <v-icon small @click="addHeader">fa-plus-circle</v-icon>
            </v-col>
          </v-row>
          <v-row v-for="(pair, index) in editedItem.headers" :key="index">
            <v-col cols="12" sm="5" lg="5" class="p-t-0">
              <v-text-field
                class="margin0 padding0"
                v-model="editedItem.headers[index].key"
                hide-details
                dense
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="7"
              lg="7"
              class="p-t-0 d-flex justify-space-between"
            >
              <v-text-field
                class="margin0 padding0"
                v-model="editedItem.headers[index].value"
                hide-details
                dense
              ></v-text-field>
              <v-icon small class="ml-1" @click="deleteHeader(index)">
                fa-trash
              </v-icon>
            </v-col>
          </v-row>
        </fieldset>
      </v-col>
      <v-col v-if="currentTab === 'body'" cols="12" sm="12" md="12" lg="12">
        <v-textarea
          v-model="editedItem.body"
          hide-details
          solo
          rows="7"
          class="textarea-input overflow-x"
          @keyup.down="pressDown"
          @keyup.up="pressUp"
          @keydown.enter="onEnter"
          @keydown.tab="pressTab"
        ></v-textarea>
        <intellisense
          :input="editedItem.body"
          :property="'body'"
          :start="start"
          :eventKey="eventKey"
          :functionName="this.apiFunctionName"
          @clearSelected="clearSelected"
          @updateInputFromIntellisense="updateInputFromIntellisense"
        />
      </v-col>
      <v-col v-if="currentTab === 'settings'" cols="12" sm="12" md="12" lg="12">
        <fieldset class="form-group m-b-0 height200px">
          <v-row class="align-center">
            <v-col class="p-b-0" cols="12" sm="6" lg="6">
              <span>Request timeout</span>
            </v-col>
            <v-col
              class="middle d-flex align-center p-b-0"
              cols="12"
              sm="6"
              lg="6"
            >
              <div>
                <v-text-field
                  class="margin0 padding0 width70px"
                  v-model="editedItem.setting.timeout"
                  type="number"
                  @blur="setPropertyData('timeout')"
                  hide-details
                  dense
                  reverse
                ></v-text-field>
              </div>
              <div class="ml-2">seconds</div>
            </v-col>
          </v-row>
        </fieldset>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Intellisense from '../../../flow/builder/components/intellisense'

export default {
  props: {
    description: String,
    functionName: String,
    editedItem: {
      type: Object,
      default: () => {
        return {
          setting: {}
        }
      }
    }
  },
  components: {
    Intellisense
  },
  data() {
    return {
      methods: ['GET', 'PUT', 'POST', 'DELETE'],
      itemsTab: [],
      currentTab: 'body',
      activeTab: 1,
      descriptionMessage: '',
      apiFunctionName: '',
      isOpenIntellisense: false,
      isKeyTab: false,
      eventKey: '',
      start: -1,
      lastValueSettingTimeout: 0
    }
  },
  created() {
    this.getDescription()
    this.getFunctionName()
    setTimeout(() => {
      this.itemsTab = ['headers', 'body', 'settings']
    }, 500)
    //ใช้เก็บ ค่าเดิมก่อนแก้ไข (last valid value)
    this.lastValueSettingTimeout = this.editedItem.setting.timeout
  },
  methods: {
    setPropertyData(property) {
      const numberPattern = /^\d+$/
      let val = 30.0
      if (!numberPattern.test(this.editedItem.setting[property])) {
        val = this.lastValueSettingTimeout
        this.editedItem.setting[property] = parseFloat(val).toFixed(1)
      } else {
        let val = this.editedItem.setting[property]

        if (val < 0) {
          val = 0
        }
        this.editedItem.setting[property] = parseFloat(val).toFixed(1)
        this.lastValueSettingTimeout = this.editedItem.setting[property]
      }
    },
    addHeader() {
      this.editedItem.headers.push({
        key: '',
        value: ''
      })
    },
    deleteHeader(index) {
      this.editedItem.headers.splice(index, 1)
    },
    getDescription() {
      if (this.description) {
        this.descriptionMessage = this.description.replace(/\\n/g, '<br/>')
      }
    },
    getFunctionName() {
      if (this.functionName) {
        this.apiFunctionName = this.functionName
      }
    },

    // start intellisense
    pressDown() {
      this.start += 1
      this.eventKey = 'keydown'
    },
    pressUp() {
      this.start -= 1
      this.eventKey = 'keyup'
    },
    pressTab() {
      this.isKeyTab = true
      this.start = -1
    },
    onEnter(e) {
      if (e.keyCode === 13 && this.start > -1) {
        this.eventKey = 'enter'
        this.start = -1
        e.preventDefault()
      }
      this.eventKey = 'enter'
      this.start = -1
    },
    clearSelected() {
      this.start = -1
    },
    updateInputFromIntellisense(property, data) {
      this.editedItem[property] = data
    }
    // end intellisense
  }
}
</script>

<style scoped lang="scss">
.width70px {
  width: 70px;
}
.margin-left {
  margin-left: 30px !important;
}
.height200px {
  min-height: 222px;
  overflow-y: auto;
}

::v-deep .v-slide-group {
  height: 30px !important;
}

::v-deep .v-slide-group__prev,
::v-deep .v-slide-group__next {
  display: none;
}

.textarea-input {
  font-size: 14px;
}
</style>
